import e from "../managers/braze-instance.js";
import r from "../../shared-lib/braze-shared-lib.js";
import O, { STORAGE_KEYS as i } from "../managers/storage-manager.js";
export function disableSDK() {
  const a = e.cr();
  a && a.requestImmediateDataFlush();
  const s = new O.ee(null, !0),
    n = "This-cookie-will-expire-in-" + s.ae();
  s.store(i.re, n);
  const o = r.zt.Ft;
  new r.xt(o, r.j).setItem(o.Jt.se, o.ie, !0),
    r.j.info("disableSDK was called"),
    e.destroy(!1),
    e.ne(!0);
}
